import { useQuery } from 'react-query'
import { Box } from './_shared/Box'
import { ChevronDown } from './icons'
import { getAdditionalProducts } from '../../../../api/newApi'
import { useChosenCompany, useUser } from '../../../../context/UserProvider'
import { formatDate } from './helpers/formatDate'
import { useState } from 'react'
import { Loader } from './_shared/Loader'
import TertiaryButton from './_shared/Buttons/TertiaryButton'
import {
  agreementCodeMapper,
  filterAdditionalProducts,
  mapAdditionalProductName,
} from '../../v3/helpers/additionalProducts'

export function AdditionalProducts({
  car,
  setShowServiceCard,
  showServiceCard,
  setAdditionalProductsOpen,
  additionalProductsOpen,
}) {
  const filteredAdditionalProducts = filterAdditionalProducts(
    car?.additionalProducts || [],
  )

  const [amountToShow, setAmountToShow] = useState(
    filteredAdditionalProducts.length < 4
      ? filteredAdditionalProducts.length
      : 4,
  )
  return (
    <Box title="Tilleggstjenester">
      <div className="flex flex-col gap-2 w-full">
        {filteredAdditionalProducts.length === 0 && (
          <p>Bilen har ingen aktive tilleggstjenester</p>
        )}
        {filteredAdditionalProducts
          ?.slice(0, amountToShow)
          ?.map((product, index) => {
            const isLast =
              index ===
              filteredAdditionalProducts.slice(0, amountToShow).length - 1
            return (
              <AdditionalProductsCard
                key={product.AgreementCode}
                product={product}
                car={car}
                isLast={isLast}
              />
            )
          })}
        {filteredAdditionalProducts.length > 4 && (
          <div className="flex w-fit justify-start">
            <TertiaryButton
              onClick={() => {
                setAmountToShow(
                  filteredAdditionalProducts.length > amountToShow
                    ? filteredAdditionalProducts.length
                    : 4,
                )
              }}
            >
              {amountToShow < filteredAdditionalProducts.length
                ? 'Vis flere tilleggstjenester'
                : 'Vis færre tilleggstjenester'}
            </TertiaryButton>
          </div>
        )}
      </div>
    </Box>
  )
}
export function AdditionalProductsCard({ product, car, isLast }) {
  const [isOpen, setIsOpen] = useState(false)
  const productCodeMapped = agreementCodeMapper(product.AgreementCode)
  return (
    <div
      className={`flex flex-col gap-4 w-full py-4 ${
        !isLast && 'border-b-[1px]'
      }`}
    >
      <button disabled={!productCodeMapped} onClick={() => setIsOpen(!isOpen)}>
        <div className="flex text-lg font-bold flex-row justify-between text-left">
          {mapAdditionalProductName(productCodeMapped)}
          {productCodeMapped && (
            <span
              className={`transform transition-transform ${
                isOpen ? 'rotate-180' : ''
              }`}
            >
              <ChevronDown />
            </span>
          )}
        </div>
      </button>
      {isOpen && <AdditionalProductsDetails product={product} car={car} />}
    </div>
  )
}

export function AdditionalProductsDetails({ product, car }) {
  const company = useChosenCompany()
  const contractId = useUser()?.user?.id

  const expenseId = agreementCodeMapper(product.AgreementCode)
  const { data, isLoading, isFetching, isError, refetch } = useQuery({
    queryFn: () =>
      getAdditionalProducts({
        accountNo: car.accountNo,
        companyId: company.id,
        expenseId: expenseId,
        contactId: contractId,
      }),
    queryKey: [
      'additionalProducts',
      car.accountNo,
      company.id,
      product.AgreementCode,
      car.driverID,
    ],
  })

  if (isLoading || isFetching) {
    return (
      <div className="min-h-[100px] flex items-center justify-center w-full">
        <Loader />
      </div>
    )
  }

  if (isError || !data) {
    return (
      <div className="min-h-[100px] flex flex-col gap-2 items-center justify-center w-full">
        <p className="text-red-500">Noe gikk galt under henting av data</p>
        <button onClick={() => refetch()}>Prøv igjen</button>
      </div>
    )
  }

  const findProductCodeInData = data?.filter((item) => {
    return item?.code === product.AgreementCode
  })

  const lastEvent =
    findProductCodeInData?.length > 0 ? findProductCodeInData?.[0] : data?.[0]
  return (
    <div className="flex text-left flex-col gap-4 bg-[#F4F7FF] p-4 rounded-md">
      <p>
        Siste hendelse:{' '}
        {lastEvent?.date
          ? formatDate(lastEvent?.date)
          : 'Ingen dato tilgjengelig'}
      </p>
      <div className="flex flex-col gap-2">
        <p>
          Beskrivelse:{' '}
          {lastEvent?.description
            ? lastEvent?.description
            : 'Ingen beskrivelse tilgjengelig'}
        </p>
        {lastEvent?.operator && <p>Operatør: {lastEvent?.operator}</p>}
      </div>
    </div>
  )
}
